<template>
  <div
    class="tc-verify-vp-row"
    :data-testid="`verify-vp-row-${entry.wbs1}-${entry.dayIndex}`"
  >
    <div class="tc-verify-vp-row-wbs">
      <span class="tc-verify-vp-row-code">{{ entry.wbs1 }}</span>
      <span class="tc-verify-vp-row-name">{{ entry.wbs1Name }}</span>
    </div>
    <div class="tc-verify-vp-row-hours">{{ entry.hours.toFixed(2) }}h</div>
  </div>
</template>

<script setup lang="ts">
// Read-only VP row inside a day group's "Already in Vantagepoint" sub-block.
// Purely presentational — the muted styling (italic name, reduced emphasis)
// lives in _verify.scss so nothing here communicates editability.
export interface VpDayEntry {
  wbs1: string;
  wbs1Name: string;
  dayIndex: number;
  hours: number;
}

defineProps<{ entry: VpDayEntry }>();
</script>
